export default __webpack_public_path__ + "static/media/2d.e1234df6.png";